<script>
/**
 * @description Компонент анимации бокового скольжения.
 * @type {Vue}
 */
export default {
  functional: true,
  render(createElement, context) {
    const options = {
      props: {
        name: 'side-slide-transition',
      },
    };
    return createElement('transition', options, context.children);
  },
};
</script>
<style>
.side-slide-transition-enter,
.side-slide-transition-leave-to {
  transform: translateX(100%);
}
.side-slide-transition-enter-active,
.side-slide-transition-leave-active {
  transition: transform .3s ease;
}
</style>
